// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;

function getProofStatus(stmt) {
  if (stmt.isHyp) {
    return /* Ready */0;
  } else {
    return stmt.proofStatus;
  }
}

function toggleFlag(idx, flags) {
  return flags.map(function (v, i) {
              if (i === idx) {
                return !v;
              } else {
                return v;
              }
            });
}

function selectProvedStmts(rootStmtsRendered, flags) {
  return flags.map(function (param, i) {
              return Belt_Option.getWithDefault(Belt_Option.map(getProofStatus(Caml_array.get(rootStmtsRendered, i)), (function (status) {
                                return status === /* Ready */0;
                              })), false);
            });
}

function MM_cmp_root_stmts(props) {
  var onClose = props.onClose;
  var flags = props.flags;
  var proofStatusesAreAvailable = props.proofStatusesAreAvailable;
  var rootStmtsRendered = props.rootStmtsRendered;
  var match = React.useState(function () {
        return {
                flags: flags
              };
      });
  var setState = match[1];
  var state = match[0];
  var rndButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onClose, state.flags);
                      }),
                    variant: "outlined",
                    children: "Done"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(setState, (function (__x) {
                                return {
                                        flags: __x.flags.map(function (param) {
                                              return false;
                                            })
                                      };
                              }));
                      }),
                    children: "None"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(setState, (function (__x) {
                                return {
                                        flags: __x.flags.map(function (param) {
                                              return true;
                                            })
                                      };
                              }));
                      }),
                    children: "All"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(setState, (function (__x) {
                                return {
                                        flags: __x.flags.map(function (v) {
                                              return !v;
                                            })
                                      };
                              }));
                      }),
                    children: "Inverse"
                  }), proofStatusesAreAvailable ? React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(setState, (function (__x) {
                                  return {
                                          flags: selectProvedStmts(rootStmtsRendered, __x.flags)
                                        };
                                }));
                        }),
                      children: "Proved"
                    }) : null);
  };
  var rndStmts = function (param) {
    var paddingTop = "10px";
    return React.createElement("table", undefined, React.createElement("tbody", undefined, state.flags.map(function (flag, i) {
                        var stmt = Caml_array.get(rootStmtsRendered, i);
                        return React.createElement("tr", {
                                    key: String(i),
                                    style: {
                                      verticalAlign: "top"
                                    }
                                  }, React.createElement("td", undefined, React.createElement(Checkbox, {
                                            checked: flag,
                                            onChange: (function (param) {
                                                Curry._1(setState, (function (__x) {
                                                        return {
                                                                flags: toggleFlag(i, __x.flags)
                                                              };
                                                      }));
                                              })
                                          })), React.createElement("td", {
                                        style: {
                                          paddingTop: paddingTop
                                        }
                                      }, proofStatusesAreAvailable ? MM_cmp_user_stmt.rndProofStatus(getProofStatus(stmt), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined) : null), React.createElement("td", {
                                        style: {
                                          paddingTop: paddingTop
                                        }
                                      }, stmt.label + ": "), React.createElement("td", {
                                        style: {
                                          paddingTop: paddingTop
                                        }
                                      }, stmt.exprReElem));
                      })));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement("span", {
                            style: {
                              fontWeight: "bold"
                            }
                          }, props.title), rndButtons(undefined), rndStmts(undefined), rndButtons(undefined)))
            });
}

var make = MM_cmp_root_stmts;

exports.make = make;
/* react Not a pure module */
